import React, { useState, useEffect } from "react";
import "./Deepplatform.scss";
import Grid from "@mui/material/Grid2";
import { Container, Button } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CPQ } from "../../helpers/constant/imageUrl";
import { useDispatch } from "react-redux";
import { setActiveIndex, show } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import { useNavigate } from "react-router-dom";
import { setActiveMenu, toggleMobileNavbar } from "../../redux/MobileSideBar";

const cards = [
  {
    id: 1,
    img: "images/crm.webp",
    title: "CRM & Sales Cloud ",
    desc: "Transform your sales process. Empower your teams with tools for lead management, opportunity tracking, and forecasting to close more deals, faster. ",
  },
  {
    id: 2,
    img: "images/heart.webp",
    title: "Service & Support Cloud ",
    desc: "Deliver exceptional customer service. Streamline support cases, empower your agents with knowledge, and build customer loyalty with every interaction. ",
  },
  {
    id: 3,
    img: "images/search.webp",
    title: "Marketing Cloud Automation ",
    desc: "Create personalized customer journeys. Drive engagement with automated email campaigns, social media marketing, and targeted advertising. ",
  },
  {
    id: 4,
    img: "images/exp.webp",
    title: "Experience Cloud ",
    desc: "Build powerful portals and websites. Connect directly with your customers, partners, or employees with secure, self-service communities. ",
  },
  {
    id: 5,
    img: "images/loc.webp",
    title: "Agent Force ",
    desc: "Streamline field operations and boost mobile productivity.  Empower your remote agents with tailored tools for scheduling, customer history, and order management, all accessible from any device. ",
  },
  {
    id: 6,
    img: "images/tableu.webp",
    title: "CRM Analytics-Tableau ",
    desc: "Transform raw data into actionable insights and forecasts.  Uncover hidden trends, predict business outcomes, and empower every team with intuitive dashboards and AI-powered analytics.",
  },
  {
    id: 7,
    img: "images/cpq.webp",
    title: "Platform(PaaS) & </br> AppExchange ",
    desc: "We leverage the Salesforce Platform (Heroku, Force.com) to build powerful custom applications that extend CRM functionality for your unique needs.",
  },
];

const Deepplatform = () => {
  const navigate=useNavigate()
  const dispatch = useDispatch();
  return (
    <div className="deep">
      <Container>
        <Grid className="deepbox">
          <Grid className="deeptext">
            <h3>
              Deep Platform Mastery,
              <br /> Driving <span> Measurable Value </span>
            </h3>
            <p>
              Our certified experts don't just implement Salesforce; we harness
              the full power of the platform to solve complex business
              problems, boost efficiency, and accelerate your growth. 
            </p>
          </Grid>

          <Grid className="gridbox">
            {cards.map((item, index) => (
              <Grid key={index} className="innerdeep">
                <div className="innerdeep-head">
                   <img  loading="lazy" src={item.img} alt={item.img} />
                  <h5 dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                </div>
                <p>{item.desc}</p>
              </Grid>
            ))}
          </Grid>

          <Grid className="btns">
            <button
              className="btn1"
              onClick={() => {
                dispatch(show("products"));
                dispatch(setNav_Item("products"));
                dispatch(setActiveIndex(null));

                //! for mobile
                dispatch(toggleMobileNavbar())
                dispatch(setActiveMenu("product"))
              }}
            >
              FIND YOUR PRODUCTS
            </button>
            <button className="btn2" onClick={()=>navigate("talktoexpert")}>GET EXPERT GUIDANCE</button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Deepplatform;
